import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { colorPalette as palette } from "./palette";
/**
 * BACKGROUND COLORS
 */

export var baseBackgroundColorTokens = {
  base: palette.grey00,
  panel: palette.grey10,
  primary: palette.grey12,
  secondary: palette.grey15,
  component: palette.tintA15,
  overlay: 'rgba(0,0,0,0.75)',
  error: palette.alertError900,
  success: palette.alertSuccess900
};
var backgroundInteractive = {
  disabled: palette.tintA15,
  hover: palette.tintA10,
  selected: palette.tintA20,
  activated: palette.tintA15,
  pressed: palette.tintA15,
  on: palette.brandPrimary,
  off: palette.tintA20
};
export var fileTypeBackgroundTokens = {
  audio: palette.vibrantA150,
  blank: palette.grey60,
  compressed: palette.vibrantA260,
  drawing: palette.vibrantA230,
  image: palette.vibrantA10,
  motion: palette.vibrantA250,
  pdf: palette.vibrantA00,
  spreadsheet: palette.vibrantA120,
  text: palette.vibrantA220,
  vector: palette.vibrantA20,
  video: palette.vibrantA200
};

var backgroundColorTokens = _objectSpread(_objectSpread({}, baseBackgroundColorTokens), {}, {
  highlight: palette.tintA40,
  interactive: backgroundInteractive,
  filetype: fileTypeBackgroundTokens
});
/**
 * TEXT COLORS
 */


var textColorTokens = {
  primary: palette.tintA100,
  body: palette.tintA90,
  secondary: palette.tintA70,
  tertiary: palette.tintA60,
  error: palette.alertError600,
  success: palette.alertSuccess600
};
/**
 * BORDER COLORS
 */

var baseBorderColorTokens = {
  primary: palette.whiteA10,
  secondary: palette.tintA15,
  error: palette.alertError700,
  success: palette.alertSuccess700
};
var borderInteractiveTokens = {
  activated: palette.tintA30,
  focused: palette.tintA50,
  selected: palette.brandPrimary,
  hover: palette.tintA20
};
export var borderColorTokens = _objectSpread(_objectSpread({}, baseBorderColorTokens), {}, {
  interactive: borderInteractiveTokens
});
/**
 * ICON COLORS
 */

export var baseIconColorTokens = {
  primary: palette.tintA60,
  error: palette.alertError600,
  success: palette.alertSuccess600
};
export var interactiveIconTokens = {
  hover: palette.tintA70,
  activated: palette.tintA100,
  disabled: palette.tintA30,
  on: palette.brandPrimary,
  off: palette.tintA40
};
export var fileTypeIconTokens = {
  audio: palette.vibrant150,
  blank: palette.grey60,
  compressed: palette.vibrant260,
  drawing: palette.vibrant230,
  image: palette.vibrant10,
  motion: palette.vibrant250,
  pdf: palette.vibrant0,
  spreadsheet: palette.vibrant120,
  text: palette.vibrant220,
  vector: palette.vibrant20,
  video: palette.vibrant200
};
export var iconColorTokens = _objectSpread(_objectSpread({}, baseIconColorTokens), {}, {
  interactive: interactiveIconTokens,
  filetype: fileTypeIconTokens
});
/**
 * NAVIGATION COLORS
 */

var baseNavIconTokens = {
  primary: palette.tintA40
};
var interactiveNavIconTokens = {
  hover: palette.tintA70,
  selected: palette.tintA100
};
export var navIconTokens = _objectSpread(_objectSpread({}, baseNavIconTokens), {}, {
  interactive: interactiveNavIconTokens
});
/**
 * ALL THE COLORS TOKENS
 */

export var colorTokens = {
  background: backgroundColorTokens,
  text: textColorTokens,
  border: borderColorTokens,
  icon: iconColorTokens,
  nav: navIconTokens,
  palette: palette
};
/**
 * Helper functions and types for handling prop specific
 * colors, like backgroundColor etc. It basically allows
 * us to support specific tokens or palette colours.
 */

export function getBackgroundColor(color) {
  var _colorTokens$backgrou;

  return (_colorTokens$backgrou = colorTokens.background[color]) !== null && _colorTokens$backgrou !== void 0 ? _colorTokens$backgrou : palette[color];
}
export function getTextColor(color) {
  var _colorTokens$text$col;

  return (_colorTokens$text$col = colorTokens.text[color]) !== null && _colorTokens$text$col !== void 0 ? _colorTokens$text$col : palette[color];
}
export function getBorderColor(color) {
  var _colorTokens$border$c;

  return (_colorTokens$border$c = colorTokens.border[color]) !== null && _colorTokens$border$c !== void 0 ? _colorTokens$border$c : palette[color];
}